/* Component for creating a discount */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button/Button";
import BackIcon from "@mui/icons-material/ArrowBackIos";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import CountryRegionSelect from "../../components/CountryRegionSelect";
import { Grid, Snackbar, Alert, InputLabel, FormControl } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { createDiscount } from "../../apis/discounts";
import { CountryType, RegionType } from "../../types/master";
import moment from "moment";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const CreateDiscount = () => {
  const state = useSelector((state: any) => state);
  const navigate = useNavigate();

  const [discountData, setDiscountData] = useState(state.discount);
  const [expiryDate, setExpiryDate] = useState("");
  const [usersAllowed, setUsersAllowed] = useState("");
  const [open, setOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [country, setCountry] = useState<CountryType | null>(null);
  const [city, setCity] = useState<RegionType | null>(null);
  const [discountBearedBy, setDiscountBearedBy] = useState<string>("");

  const goToBack = () => navigate("/discounts");

  const openSnackBar = () => {
    setOpen(true);
  };
  const closeSnackBar = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
  };

  const onHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDiscountData({ ...discountData, [event.target.name]: event.target.value });
  };

  const onUsersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsersAllowed(event.target.value);
  };

  const onCreate = async () => {
    //check the required fields
    if (
      discountData &&
      country?.country_code &&
      city?.region_code &&
      discountData.type &&
      discountData.max_discount_amount &&
      discountData.min_discount_amount &&
      discountData.min_order_amount &&
      discountData.percentage &&
      discountData.promo_code &&
      expiryDate &&
      discountBearedBy !== ""
    ) {
      let users_allowed = usersAllowed.split(",");
      const newData = {
        ...discountData,
        country_code: country?.country_code,
        region_code: city?.region_code,
        expiry_date: expiryDate,
        users_allowed: users_allowed,
        discount_amount_beared: discountBearedBy,
      };
      let res = await createDiscount(newData);
      if (res?.status) {
        navigate("/discounts");
      }
    } else {
      setStatusMessage("Please fill in all the required fields.");
      openSnackBar();
    }
  };

  const onExpiryDateChange = (value: any) => {
    setExpiryDate(moment(value.toISOString()).format("YYYY-MM-DD HH:mm:ss"));
  };

  useEffect(() => {}, []);

  const handleDiscountBearedByChange = (event: SelectChangeEvent) => {
    setDiscountBearedBy(event.target.value as string);
  };

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box style={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <Box>
            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: "20px" }}>
                Create Discount
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItem: "center",
                  marginBottom: "20px",
                }}
              >
                <Button variant="contained" onClick={goToBack} startIcon={<BackIcon />}>
                  Back
                </Button>
              </Box>

              <Box
                sx={{
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <Box
                  style={{
                    padding: "20px",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6} md={8}>
                      <CountryRegionSelect
                        country={country}
                        setCountry={setCountry}
                        city={city}
                        setCity={setCity}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="outlined-basic"
                        size="small"
                        placeholder="Type"
                        label="Type"
                        name="type"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Percentage"
                        label="Percentage"
                        name="percentage"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Minimum Order Amount"
                        label="Minimum Order Amount"
                        name="min_order_amount"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Maximum Order Amount"
                        label="Maximum Order Amount"
                        name="max_order_amount"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Minimum Discount Amount"
                        label="Minimum Discount Amount"
                        name="min_discount_amount"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Maximum Discount Amount"
                        label="Maximum Discount Amount"
                        name="max_discount_amount"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Minimum Rides Required"
                        label="Minimum Rides Required"
                        name="min_rides_required"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        required
                        id="standard-basic"
                        size="small"
                        placeholder="Promo Code"
                        label="Promo Code"
                        name="promo_code"
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            onChange={onExpiryDateChange}
                            label="Expiry date"
                            sx={{ width: "100%" }}
                            slotProps={{
                              textField: {
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <TextField
                        id="standard-basic"
                        size="small"
                        label="Users Allowed"
                        helperText="Enter comma seperated values for user's email"
                        name="users_allowed"
                        value={usersAllowed}
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onUsersChange}
                      />
                    </Grid>
                    <Grid item xs={2} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">Discount Beared By</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={discountBearedBy}
                          label="Discount Beared By"
                          onChange={handleDiscountBearedByChange}
                          fullWidth
                          size="small"
                        >
                          <MenuItem value="teracar">Teracar</MenuItem>
                          <MenuItem value="driver">Driver</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItem: "center",
                  }}
                >
                  <Button variant="contained" onClick={onCreate}>
                    Create
                  </Button>
                  <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={open}
                    autoHideDuration={3000}
                    onClose={closeSnackBar}
                  >
                    <Alert
                      onClose={closeSnackBar}
                      severity="error"
                      sx={{ width: "100%", alignItems: "center" }}
                    >
                      {statusMessage}
                    </Alert>
                  </Snackbar>
                </Box>
              </Box>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateDiscount;
